import * as moment from "moment-timezone";

import { FilterType } from "src/library/components/Tables/Table";
import { ITerminology } from "src/library/utils/string-manipulations/tokenize-string";
import { getOrderStatusIdFromCode } from "src/core/orders/utils/orderStatus";
import {
  IOrderStatus,
  IOrder
} from "src/core/orders/api/orders.api";

interface QuickOrderFiltersParams {
  terminology: ITerminology;

  orderStatuses: IOrderStatus[];
}

export const quickOrderFilters = ({ terminology, orderStatuses }: QuickOrderFiltersParams): Array<FilterType<IOrder>> => {
  const orderStatusIds = {
    draft: getOrderStatusIdFromCode(orderStatuses, "draft"),
    cancelled: getOrderStatusIdFromCode(orderStatuses, "cancelled"),
    error: getOrderStatusIdFromCode(orderStatuses, "error")
  };

  const filterTypes: Array<FilterType<IOrder>> = [
    {
      text: `Show all ${terminology.order.plural.text}`,
      value: "show_all",
      filter: {}
    },
    {
      text: `Show ${terminology.order.plural.text} due to be delivered this week`,
      value: "delivery_this_week",
      filter: {
        orderStatusId: {
          $not: [
            orderStatusIds.draft,
            orderStatusIds.cancelled,
            orderStatusIds.error
          ]
        },
        orderDeliveryDate: {
          $between: [
            moment
              .utc()
              .startOf("day")
              .toDate(),
            moment
              .utc()
              .endOf("week")
              .toDate()
          ]
        }
      }
    },
    {
      text: `Show ${terminology.order.plural.text} created in the last 7 days`,
      value: "created_last_7_days",
      filter: {
        createdAt: {
          $between: [
            moment
              .utc()
              .subtract(7, "days")
              .toDate(),
            moment.utc().toDate()
          ]
        }
      }
    },
    {
      text: `Show all ${terminology.order.plural.text} with errors`,
      value: "errors",
      filter: { orderStatusId: orderStatusIds.error }
    },
    {
      text: `Show ${terminology.order.plural.text} created from a list`,
      value: "from_list",
      filter: { listId: { $not: null } }
    }
  ];

  return filterTypes;
};
